import { memo, useMemo } from 'react';
import Carousal from '../Carousal'
import { CarousalTypes } from '../Carousal/types'
import { CarousalAgeProps } from './types'

const CarousalAge = ({ onAgeSelectionChange, id }: CarousalAgeProps) => {
  const listData = useMemo(
    () => [
      { key: '0', text: '<1' },
      { key: '1', text: '1' },
      { key: '2', text: '2' },
      { key: '3', text: '3' },
      { key: '4', text: '4' },
      { key: '5', text: '5' },
      { key: '6', text: '6' },
      { key: '7', text: '7' },
      { key: '8', text: '8' },
      { key: '9', text: '9' },
      { key: '10', text: '10' },
      { key: '11', text: '11' },
      { key: '12', text: '12' },
    ],
    [],
  )
  const onSelectionChange = (index: number) => {
    const text = listData[index % 13].text
    if (onAgeSelectionChange) {
      onAgeSelectionChange(text, id)
    }
  }
  return <Carousal data={listData} type={CarousalTypes.CHILD_AGE} isRepeating onSelectionChange={onSelectionChange} />
}

export default memo(CarousalAge)
